import React from 'react';
import { KFLIcon } from '@kamstrup/kamstrup-frontend-library';

import './navLinkBtn.scss';

const emptyFn = () => {};

interface Props {
  onClick?: () => void;
}

const NavLinkBtn: React.FC<Props> = (props) => {
  const onClick = props.onClick || emptyFn;
  return (
    <div className="navlink" onClick={onClick}>
      <span className="navlink_content">{props.children}</span>
      <span className="navlink_icon">
        <KFLIcon name="Next" />
      </span>
    </div>
  );
};

export default NavLinkBtn;
